import { css } from '@emotion/react'
import { ComponentPropsWithoutRef } from 'react'

import { BodyTextBlock } from '@/features/common/'
import { Deco } from '@/features/common/'
import { mq } from '@/theme/mixins'
import { colors } from '@/theme/variables'

import { AdmissionDoorway } from './AdmissionDoorway'

interface Props extends ComponentPropsWithoutRef<'section'> {
  heading?: string | null
  body?: Queries.BodyTextBlockShortFragment | null
  doorways?: readonly (Queries.AdmissionDoorwayFragment | null)[] | null
}

export const AdmissionDoorwaysSection = ({
  heading,
  body,
  doorways,
  ...props
}: Props): JSX.Element => {
  const styles = {
    section: css`
      background: #fff;
      padding: var(--row-108) var(--margin);
      display: grid;
    `,
    heading: css`
      font-size: var(--fs-60);
      text-transform: uppercase;
      display: grid;
      justify-items: center;
      text-align: center;
      margin: 0 0 0.5em;
      span {
        margin: 0 0 0.5em;
      }
    `,
    body: css`
      justify-self: center;
      margin-bottom: 2em;
      ${mq().s} {
        margin-bottom: 1.5em;
      }
    `,
    doorways: css`
      display: grid;
      grid-template-columns: repeat(${doorways?.length}, 1fr);
      gap: 1rem;
      ${mq().s} {
        grid-template-columns: 1fr;
      }
    `,
  }
  return (
    <section
      css={styles.section}
      {...props}
    >
      <h2 css={styles.heading}>
        <span>{heading}</span>
        <Deco fill={colors.red} />
      </h2>
      <div css={styles.body}>
        <BodyTextBlock data={body} />
      </div>
      <div css={styles.doorways}>
        {doorways?.map((block, i) => (
          <AdmissionDoorway
            data={block}
            key={i}
          />
        ))}
      </div>
    </section>
  )
}
